import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 18,
	viewBox: "0 0 18 18",
	width: 18,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipRule: "evenodd",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m17.64 9.20419c0-.63818-.0573-1.25182-.1636-1.84091h-8.4764v3.48132h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2582h2.9087c1.7018-1.5668 2.6836-3.8741 2.6836-6.61501z",
				fill: "#4285f4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m8.99976 18c2.43004 0 4.46724-.8059 5.95634-2.1805l-2.9086-2.2582c-.8059.54-1.8368.8591-3.04774.8591-2.34409 0-4.32818-1.5832-5.03591-3.7104h-3.006819v2.3318c1.480909 2.9413 4.524549 4.9582 8.042729 4.9582z",
				fill: "#34a853"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m3.96409 10.7098c-.18-.54-.28227-1.11679-.28227-1.70997 0-.59319.10227-1.17.28227-1.71v-2.33182h-3.006817c-.609546 1.215-.957273 2.58954-.957273 4.04182 0 1.45227.347727 2.82677.957273 4.04177z",
				fill: "#fbbc05"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m8.99976 3.57955c1.32134 0 2.50774.45409 3.44044 1.3459l2.5814-2.58136c-1.5587-1.452272-3.5959-2.34409-6.02184-2.34409-3.51818 0-6.56182 2.01682-8.042729 4.95818l3.006819 2.33182c.70773-2.12727 2.69182-3.71045 5.03591-3.71045z",
				fill: "#ea4335"
			})
		]
	})
});
export { SvgGoogleLogo as ReactComponent };
